import type { RouteObject } from 'react-router';
import type { RouteHandle } from '@/hooks/useRouteHandle';

const page = (name: string) => () =>
  import(`./pages/${name}.tsx`).then((m) => ({ Component: m[name] }));

export const programRoutes: RouteObject[] = [
  {
    path: 'programs/:id',
    lazy: page('ProgramDetailPage'),
    handle: { title: '사업 상세', feature: 'PROGRAM_DETAIL' } satisfies RouteHandle,
  },
];
